<template>
  <div id="app" class="d-flex flex-column min-vh-100" v-if="loaded">
    <Header />
    <div class="gradient-divider"></div>

    <main class="flex-fill">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import axios from './api/axios';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      user: null,
      loaded: false
    };
  },
  methods: {
    fetchLoginInfo() {
      axios.get('/logininfo')
        .then(response => {
          this.user = response.data;
          this.loaded = true;
        })
        .catch(error => {
          console.error('Error fetching login info:', error);
          this.loaded = true;
        });
    },
    logout() {
      // 确保删除 token cookie
      this.$cookies.remove('token', '/');
      
      // 尝试使用不同的路径和域名
      this.$cookies.remove('token', '/', window.location.hostname);
      this.$cookies.remove('token', '/', `.${window.location.hostname}`);
      this.user = null;
      window.location.href = '/';
    }
  },
  created() {
    this.fetchLoginInfo();
  },
  provide() {
    return {
      user: () => this.user,
      logout: this.logout
    };
  }
};
</script>

<style>
body {
  background: linear-gradient(135deg, #0d1b2a 0%, #1d2d50 100%);
  color: #f0f0f0;
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
}

.footer {
  background-color: #1f1f1f;
  color: #00e0ff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: rgba(255, 255, 255, 0.95);
}

.container {
  max-width: 960px;
}

.navbar {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.navbar-brand {
  font-weight: bold;
  color: #00e0ff;
  text-shadow: 0 0 5px rgba(0, 224, 255, 0.5);
}

.gradient-divider {
  width: 100%;
  clear: both;
  display: block;
  height: 5px;
  background: linear-gradient(to right, #00e0ff, #ff00ff, #00ff80);
  /* border-radius: 2px; */
  margin-top: -4px;
  position: fixed;
  top: 60px;
}

.table-dark {
  --bs-table-bg: rgba(0,0,0,0.1) !important;
  --bs-table-striped-bg: rgba(0,0,0,0.2) !important;
}

h3{
  background-color:#2A013499;
  padding: 15px;
}
h5{
  color: #CCCCCC;

  padding: 15px 15px 15px 0;
}
.flex-fill {
  margin-top: 60px;
}
</style>